// 平行节点
export const parallelOptions = [
    {
        name: '国盾链',
        execer: 'user.p.guodun.token',
        provider: 'https://beanwallet.com/api'
    },
    {
        name: '预售链',
        execer: 'user.p.sto.',
        provider: 'https://47.110.90.242:8801'
    }
]

export default parallelOptions
